export const PHARMA_META_DESCRIPTION_BG =
  "Медиен мониторинг и медийни анализи за фармацевтични брандове в Югоизточна Европа - регулаторни решения, безопасност на лекарствата и анализ на репутацията.";
